<template>
  <div class="consult">
    <h1>{{mesg.title}}</h1>
    <div class="cons-time">
      <img src="./images/时间.png" alt />
      <p>{{mesg.createTime | timeFun}}</p>
    </div>
    <div class="cons-imgs-w">
      <img :src="'http://zhongshui.365hy.com/' + mesg.img" alt />
    </div>
    <div v-html="mesg.details" class="mesg-data"></div>
  </div>
</template>

<script>
import request from "@/network/request.js";
export default {
  name: "consult",
  data() {
    return {
      mesg: ""
    };
  },
  created: function() {
    console.log("id", this.$route.query.id);
    request({
      url: "/zhongshui/information/select",
      method: "post",
      params: {
        id: parseInt(this.$route.query.id)
      }
    })
      .then(res => {
        console.log(res);
        this.mesg = res.data;
      })
      .catch(err => {
        console.log("请求错误");
      });
  },
  filters: {
    timeFun: function(value) {
      let date = new Date(value);
      let str =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return str;
    }
  }
};
</script>
<style>
.mesg-data img{
    width: 100%;
}
</style>
<style lang="scss" scoped>
.consult {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1040px;
  margin: 40px auto;
  // margin-top: 40px;
  .cons-time {
    display: flex;
    margin: 18px 0;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      margin-right: 7px;
    }
    p {
      font-size: 15px;
    }
  }
  .cons-imgs-w {
    width: 100%;
    margin-bottom: 20px;
    img {
      width: 100%;
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/common/consult-mess.vue